import { PsvReviewItemKind } from "@api/shared-runtime/psv-review";
import type {
  ReportItem,
  RunReport,
} from "@/features/credentials/components/primary-source-runs/types";
import {
  findDecidingResult,
  findItemCheck,
} from "@/features/credentials/components/primary-source-runs/run-report-dialog/item-status";

type Check = RunReport["checks"][number];

const FALLBACK_SOURCE_NAME = "Source check";

/** The check the row's date and source describe: a license's deciding source,
 * or the item's own check. */
export function itemSourceCheck({
  item,
  checks,
}: {
  item: ReportItem;
  checks: Check[];
}): Check | undefined {
  if (item.kind === PsvReviewItemKind.StateLicense) {
    const sources = item.license?.sources ?? [];
    const source = sources.find((entry) => entry.decides) ?? sources[0];
    return checks.find((check) => check.id === source?.checkId);
  }
  return findItemCheck({ item, checks });
}

/** The authority that answered. For a license that is the board its deciding
 * result names ("Medical Board of California", as the board record shows);
 * the source and check only carry a short label ("California"), which stands
 * in until a result is saved. */
export function itemSourceName({
  item,
  checks,
}: {
  item: ReportItem;
  checks: Check[];
}): string {
  if (item.kind === PsvReviewItemKind.StateLicense) {
    const facts = findDecidingResult({ item, checks })?.result.facts as
      | Record<string, unknown>
      | undefined;
    const board = facts?.authorityName;
    if (typeof board === "string" && board) {
      return board;
    }
  }
  return (
    itemSourceCheck({ item, checks })?.authorityName ?? FALLBACK_SOURCE_NAME
  );
}
